module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/3-e67c302b9e1e75498e727ba5f34334c0.png";